import React, { useState } from 'react';
const faqs = [{
  q: 'Is this suitable for beginner PE teachers?',
  a: 'Absolutely. The system is designed to work whether you have 1 year of experience or 20. Every session is fully structured with clear objectives, warm-ups, activities, and cool-downs. You just follow the plan.'
}, {
  q: 'What age groups does this cover?',
  a: 'P.E. READY 360 covers all school age groups from beginners through to advanced high school level. Every volume includes adaptations for different ages and skill levels.'
}, {
  q: 'Is this a physical or digital product?',
  a: 'This is a 100% digital product. You receive everything as high-quality PDF files instantly after purchase. No shipping, no waiting, no apps required.'
}, {
  q: 'How do I receive my purchase?',
  a: 'Immediately after payment you receive a download link via email. One click and the entire bundle is on your device. Works on phone, tablet, laptop, or print.'
}, {
  q: 'What if I am not satisfied?',
  a: 'You are fully covered by our 7-day money-back guarantee. No questions, no forms, no hassle. Just send us one email and we refund you in full.'
}, {
  q: 'Can I use this for school PE classes?',
  a: 'Yes. P.E. READY 360 was specifically designed for PE teachers in schools. Every session plan, assessment tool, and planning resource is built around the school environment.'
}, {
  q: 'How is this different from free resources online?',
  a: 'Free resources are scattered, inconsistent, and not connected to any progression system. P.E. READY 360 is a complete curriculum built on a logical annual progression. It saves you hundreds of hours per year.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-16 px-4" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] text-center mb-10 tracking-tight" data-id="element-37">
          Frequently Asked <span className="text-[#FF6B00]" data-id="element-38">Questions</span>
        </h2>

        <div className="bg-white border border-[#E5E5EA] rounded-2xl divide-y divide-[#E5E5EA] overflow-hidden shadow-sm" data-id="element-39">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-[#FAFAFA] hover:bg-white transition-colors" data-id="element-40">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-41">
                  <span className="text-[#0A0A0A] font-black text-base" data-id="element-42">
                    {faq.q}
                  </span>
                  <span className={`text-[#FF6B00] text-xl font-black flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-43">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-6 pb-5 -mt-2" data-id="element-44">
                    <p className="text-[#5A5A66] text-sm sm:text-base font-medium leading-relaxed" data-id="element-45">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}